import styled from 'styled-components';

export const StyledMedicalCertificateForm = styled.form`
   width: 800px;
   display: flex;
   flex-direction: column;
   gap: 24px;
`;

StyledMedicalCertificateForm.displayName = 'StyledMedicalCertificateForm';
